import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	breadcrumbs: {
		id: 'spa-apps.project-settings.service-desk-chat-settings.chat-settings.breadcrumbs',
		defaultMessage: 'Chat',
		description: 'breadcrumbs for Chat settings page',
	},
	title: {
		id: 'spa-apps.project-settings.service-desk-chat-settings.chat-settings.title',
		defaultMessage: 'Chat',
		description: 'title of the Chat settings page',
	},
	installingChat: {
		id: 'spa-apps.project-settings.service-desk-chat-settings.chat-settings.installing-chat',
		defaultMessage: 'We’re setting up chat for you. This may take a few minutes.',
		description: 'Message displayed to users while the Chat is being installed.',
	},
	getChatAppStatusErrorBeforeLink: {
		id: 'spa-apps.project-settings.service-desk-chat-settings.chat-settings.get-chat-app-status-error-before-link',
		defaultMessage: 'We couldn’t load chat.',
		description:
			'Error message displayed before the link, when there was an error loading the chat add-on',
	},
	getChatAppStatusErrorLinkText: {
		id: 'spa-apps.project-settings.service-desk-chat-settings.chat-settings.get-chat-app-status-error-link-text',
		defaultMessage: 'Refresh the page',
		description:
			'Link text in the error message displayed when there was an error loading the chat add-on',
	},
	getChatAppStatusErrorAfterLink: {
		id: 'spa-apps.project-settings.service-desk-chat-settings.chat-settings.get-chat-app-status-error-after-link',
		defaultMessage: ' and try again.',
		description:
			'Error message displayed after the link, when there was an error loading the chat add-on',
	},
	installChatAppErrorBeforeLink: {
		id: 'spa-apps.project-settings.service-desk-chat-settings.chat-settings.install-chat-app-error-before-link',
		defaultMessage: 'We couldn’t install chat.',
		description:
			'Error message displayed before the link, when there was an error installing the chat add-on',
	},
	installChatAppErrorLinkText: {
		id: 'spa-apps.project-settings.service-desk-chat-settings.chat-settings.install-chat-app-error-link-text',
		defaultMessage: 'Refresh the page',
		description:
			'Link text in the error message displayed when there was an error installing the chat add-on',
	},
	installChatAppErrorAfterLink: {
		id: 'spa-apps.project-settings.service-desk-chat-settings.chat-settings.install-chat-app-error-after-link',
		defaultMessage: 'and try again.',
		description:
			'Error message displayed after the link, when there was an error installing the chat add-on',
	},
	channelBreadcrumb: {
		id: 'spa-apps.project-settings.service-desk-chat-settings.chat-settings.channel-breadcrumb',
		defaultMessage: 'Channels',
		description: 'breadcrumbs for Channels',
	},
});
